/*@flow*/
import type { Node } from 'react';
import React, { Fragment } from 'react';
import * as t from 'lib/t';
import cx from 'classnames';
import Breakpoints from '../util/Breakpoints';
import Label from './Label';
import ErrorComponent from './ErrorComponent';
import Help from './Help';
import FormGroup from './FormGroup';
import type { LocalsT, DateTimeLocals } from '../types';
import VerticalCols from './VerticalCols';

type PropsT = {
  ...$Exact<LocalsT>,
  ...$Exact<DateTimeLocals>,
};

const DateConfig = t.struct(
  {
    horizontal: t.maybe(Breakpoints),
    vertical: t.maybe(Breakpoints),
  },
  'DateConfig'
);

function getConfig(locals: PropsT) {
  return DateConfig(locals.config || {});
}

function getAttrs(locals: PropsT) {
  return { ...locals.attrs };
}

function LabelWrapper(locals: PropsT) {
  return (
    <Label
      {...{
        label: locals.label,
        breakpoints: locals.config.horizontal,
        className: cx({ 'text-danger font-weight-bold': locals.hasError }),
      }}
    />
  );
}

function padZero(str) {
  if (!str) return str;
  return str.padStart(2, '0');
}

function DateComponent(locals: PropsT) {
  const v = locals.value || [];
  const value = v.map(padZero).join('-');

  function onChange(evt) {
    const newValue = evt.target.value.trim() || '';
    locals.onChange(newValue.split('-'));
  }

  return (
    <input
      type="date"
      disabled={locals.disabled}
      className="form-control"
      value={value}
      onChange={onChange}
    />
  );
}

function Vertical(locals: PropsT) {
  return (
    <Fragment>
      <LabelWrapper {...locals} />
      <VerticalCols {...locals}>
        <DateComponent {...locals} />
        <Help {...locals} />
        <ErrorComponent {...locals} />
      </VerticalCols>
    </Fragment>
  );
}

function Horizontal(locals: PropsT) {
  const className = locals.label
    ? locals.config.horizontal.getInputClassName()
    : locals.config.horizontal.getOffsetClassName();

  return (
    <div className="form-row">
      <LabelWrapper {...locals} />
      <div className={cx(className)}>
        <DateComponent {...locals} />
        <ErrorComponent {...locals} />
        <Help {...locals} />
      </div>
    </div>
  );
}
export default (props: PropsT): Node => {
  const config = getConfig(props);
  const attrs = getAttrs(props);
  const locals = { ...props, attrs, config };

  const children = locals.config.horizontal ? (
    <Horizontal {...locals} />
  ) : (
    <Vertical {...locals} />
  );

  return <FormGroup {...locals}>{children}</FormGroup>;
};
